import { render, staticRenderFns } from "./IphoneXFrame.vue?vue&type=template&id=112b6e68&scoped=true&"
import script from "./IphoneXFrame.vue?vue&type=script&lang=ts&"
export * from "./IphoneXFrame.vue?vue&type=script&lang=ts&"
import style0 from "./IphoneXFrame.vue?vue&type=style&index=0&id=112b6e68&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b6e68",
  null
  
)

export default component.exports